import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Grid, Paper, useMediaQuery } from '@mui/material';
import Titlebar from '../TitleBar';
import { Pagination, SearchTable, TableBody2, TableBottom2, TableHeader } from '.';
import Table from '@mui/material/Table';
import TableContainer from '@mui/material/TableContainer';
import { applyFilter, emptyRows, getComparator, extractDate } from '../../Utils/table';
import { adminStkInwMenu, StkInwMenu, UStkInwMenu, Zones } from '../TitleList';
import { fetchSchlStockDetails, fetchUserStkInwData } from '../../Store/PHPSlice/StkInw';
import { selectLocations, selectSchlStkDetails, selectUstkInwdata } from '../Selectors/Master/OutwardSelectors';
import DateInputComponent2 from '../FieldsComponents/DateInputComponent2';
import styled, { cutDates, inputStyles, stockNumber, inputNumbersmall, inputStyle11 } from '../../Utils/inputChanges';
import { fetchLocationData } from '../../Store/PHPSlice/LocationApi';
import Dropdown from '../FieldsComponents/Dropdown';
import axios from 'axios';


const UstkDetailsReg = () => {
    const userdata = JSON.parse(sessionStorage.getItem('user'));
    const baseUrl = process.env.REACT_APP_BASE_URL;
    const dispatch = useDispatch();
    const getItems = useSelector(selectSchlStkDetails);
    const allschls = useSelector(selectLocations);
    const [order, setOrder] = useState('asc');
    const [orderBy, setOrderBy] = useState('empId');
    const [selected, setSelected] = useState([]);
    const [filterName, setFilterName] = useState('null');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [recordsPerPage, setRecordsPerPage] = useState(10);
    const [searchQuery, setSearchQuery] = useState("");
    const [firstIndex, setFirstIndex] = useState(0);
    const [lastIndex, setLastIndex] = useState(0);
    const [activeMenu, setActiveMenu] = useState(StkInwMenu);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [pageRange, setPageRange] = useState([0, 10]); // Initial range [0, 10]
    const [searchTerm, setSearchTerm] = useState('');
    const isDesktop = useMediaQuery('(min-width:768px)');


    const [formData, setFormData] = useState({
        fdt: '',
        tdt: '',
        barcd: '',
        schlId: ''
    });
    const [schlList, setSchlList] = useState([]);
    useEffect(() => {
        if (userdata?.role !== '1') {
            dispatch(fetchSchlStockDetails({ id: userdata?.ID }));
        } else {
            dispatch(fetchSchlStockDetails());
            dispatch(fetchLocationData());
        }
    }, [dispatch]);

    useEffect(() => {

        if (userdata?.pageIds?.length > 0 && userdata?.role === '2') {
            const pid = userdata?.pageIds?.find(item => item === 1);
            if (pid === 1 && userdata?.role === '3') {
                setActiveMenu(adminStkInwMenu);
            } else if (userdata?.role === '2') {
                setActiveMenu(UStkInwMenu);
            } else {
                setActiveMenu(StkInwMenu);
            }

            const selectpid = userdata?.pageIds?.filter(item => item === 1 || item === 2);
            if (selectpid?.length > 0) {
                const data = {
                    uid: userdata?.ID,
                    pageId: selectpid
                };
                fetchPageAssignSchools(data);
            }
        }
    }, []);

    const fetchPageAssignSchools = async (id) => {
        const { uid, pageId } = id;
        try {
            const response = await axios.get(`${baseUrl}?apicall=getUserwisePageIdSchools&uid=${uid}&pageId=${pageId}`);
            setSchlList(response?.data?.data);
            // console.log(response.data)

        } catch (error) {
            console.error('Error fetching info list:', error);
        }
    };

    if (!getItems) {
        return <h1>Loading...</h1>;
    }

    // console.log(getItems)

    const compData = Array.isArray(getItems.data) ? getItems.data.map((item, index) => (
        {
            srNo: item.ID,
            stkBarcode: item.stkBarcode,
            stkId: item.stkId,
            itemId: item.itemId,
            itemNm: item.itemNm,
            size: item.size,
            color: item.color,
            qty: item.qty,
            bqty: item.bqty,
            disrate: item.disrate,
            disamt: item.disamt,
            srate: item.srate,
            schlId: item.schlId,
            schlcd: item.schlcd,
            schlNm: item.schlNm,
            serialNumber: index + 1
        }
    )) : [];


    const handleSort = (event, id) => {
        const isAsc = orderBy === id && order === 'asc';
        if (id !== '') {
            setOrder(isAsc ? 'desc' : 'asc');
            setOrderBy(id);
        }
    };
    const handleSelectAllClick = (event) => {
        if (event.target.checked) {
            const newSelecteds = compData.map((n) => n.name);
            setSelected(newSelecteds);
            return;
        }
        setSelected([]);
    };

    const handleClick = (event, name) => {
        const selectedIndex = selected.indexOf(name);
        let newSelected = [];
        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, name);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1)
            );
        }
        setSelected(newSelected);
    };

    const handleChangeCPage = (n) => {
        setCurrentPage(n);
    };
    const handlePrevPage = () => {
        if (currentPage !== firstIndex) {
            setCurrentPage(currentPage - 1);
        }
    };

    const handleNextpage = () => {
        if (currentPage !== lastIndex) {
            setCurrentPage(currentPage + 1);
        }
    };

    const handleRecordsPerPageChange = (event) => {
        setRecordsPerPage(parseInt(event.target.value, 10)); // Parse selected value to integer
        setCurrentPage(0); // Reset current page when records per page changes
    };

    const totalCount = compData.length;
    const npages = Math.ceil(totalCount / recordsPerPage);
    const numbers = Array.from({ length: npages }, (_, i) => i + 1);




    const handleSearchChange = (event) => {
        setSearchTerm(event.target.value);
        setCurrentPage(1); // Reset to first page on search
    };

    const filteredData = (Array.isArray(compData) ? compData : []).filter(item =>
        item?.itemNm?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item?.stkBarcode?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item?.schlcd?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item?.schlNm?.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const saledata = filteredData?.map(item => ({
        key: item.key,
        sqty: parseFloat(item.qty) - parseFloat(item.bqty)
    }));

    const totsaleqty = saledata?.reduce((acc, sum) => acc + parseFloat(sum.sqty), 0);
    const totstkqty = filteredData?.reduce((acc, sum) => acc + parseFloat(sum.qty), 0);
    const totbalqty = filteredData?.reduce((acc, sum) => acc + parseFloat(sum.bqty), 0);
    const totdisrate = filteredData?.reduce((acc, sum) => acc + parseFloat(sum.disrate), 0);
    const totdisamt = filteredData?.reduce((acc, sum) => acc + parseFloat(sum.disamt), 0);

    const dataFiltered = applyFilter({
        inputData: filteredData,
        comparator: getComparator(order, orderBy),

    });
    // console.log(filteredData);


    const totalPages = Math.ceil(dataFiltered.length / itemsPerPage);
    const displayedData = dataFiltered.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);


    const pageNumbers = Array.from({ length: totalPages }, (_, index) => index + 1);
    const visiblePageNumbers = pageNumbers.slice(pageRange[0], pageRange[1]);

    const handleNextPageRange = () => {
        setPageRange([pageRange[0] + 5, pageRange[1] + 5]);
    };

    const handlePreviousPageRange = () => {
        setPageRange([pageRange[0] - 5, pageRange[1] - 5]);
    };

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const handleItemsPerPageChange = (event) => {
        setItemsPerPage(Number(event.target.value));
        setCurrentPage(1); // Reset to first page on change
    };
    // console.log(displayedData);


    const fields = [
        { label: 'From Date', name: 'fdt', type: 'date' },
        { label: 'To Date', name: 'tdt', type: 'date' },
        // { label: 'Barcode', name: 'freight_ch' },
    ];

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value.toUpperCase()
        });

    };

    const handleSearch = (e) => {
        e.preventDefault();

        // if (formData.fdt === '') {
        //     alert('Please Select From Date.');
        //     return; // Stop form submission
        // }
        // if (formData.tdt === '') {
        //     alert('Please Select To Date.');
        //     return; // Stop form submission
        // }

        dispatch(fetchSchlStockDetails({ fdt: formData.fdt, tdt: formData.tdt, userId: userdata?.ID, schlId: formData.schlId }));
    };

    const handleDropdownChange = (e, dropdownType) => {
        const { value } = e.target;
        setFormData({
            ...formData,
            [dropdownType]: value
        });

    };


    const dropdownOrdType = [

        {
            label: 'School',
            id: 'schlId',
            options: userdata?.role !== '1' ? schlList : allschls?.data || [],
            value: formData.schlId,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'schlId', value: newValue ? newValue.ID : '' } }, 'schlId'),
            getOptionLabel: (option) => option.schlcd || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
            bold: true,

        }

    ];
    return (
        <>
            {/* <Titlebar data={userdata?.role === '2' ? UStkInwMenu : StkInwMenu} /> */}
            <Titlebar data={activeMenu} />
            <div style={{ margin: '1% 0.5%' }}>
                <h2>School Stock (Barcode) Details</h2>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Paper style={{ padding: '3vh', margin: '0' }}>

                            <Grid container spacing={0.5}>
                                {fields.map((field) => (
                                    <DateInputComponent2
                                        key={field.name}
                                        formData={formData}
                                        handleDateChange={handleInputChange}
                                        handleInputChange={handleInputChange}
                                        styled={styled}
                                        inputStyles={inputStyles}
                                        isDesktop={isDesktop}
                                        field={field}
                                    />
                                ))}

                                {
                                    dropdownOrdType?.map((drop) => (
                                        <Dropdown
                                            key={drop.label}
                                            label={drop.label}
                                            id={drop.id}
                                            options={drop.options}
                                            value={drop.value}
                                            onChange={drop.onChange}
                                            isDesktop={isDesktop}
                                            getOptionLabel={drop.getOptionLabel}
                                            isOptionEqualToValue={drop.isOptionEqualToValue}
                                            valueFinder={drop.valueFinder}  // Pass `valueFinder` function here

                                        />
                                    ))
                                }

                                <Grid item xs={12} textAlign="center">
                                    <Button variant="contained" color="primary" onClick={handleSearch}>Search</Button>

                                </Grid>
                            </Grid>

                            <Grid item xs={12} textAlign="center" style={{ marginTop: '4%' }}>
                            </Grid>

                            <SearchTable
                                handleItemsPerPageChange={handleItemsPerPageChange}
                                searchTerm={searchTerm}
                                handleSearchChange={handleSearchChange}
                                totalItems={filteredData?.length}
                            />


                            <TableContainer style={{ marginTop: '2%', border: '1px solid #ccc' }}>
                                <Table>
                                    <TableHeader
                                        headCells={[
                                            { id: 'srNo', label: 'Sr.No' },
                                            { id: 'stkBarcode', label: 'Barcode' },
                                            { id: 'schlcd', label: 'School Code' },
                                            { id: 'itemNm', label: 'Item' },
                                            { id: 'size', label: 'Size' },
                                            { id: 'color', label: 'Color' },
                                            { id: 'qty', label: 'Stock Qty' },
                                            { id: '', label: 'Sale Qty' },
                                            { id: 'bqty', label: 'Bal Qty' },
                                            { id: 'disrate', label: 'Sale Rate' },
                                            { id: 'disamt', label: 'Total Amt.' },
                                            // { id: 'view', label: 'View' },
                                            // { id: 'edit', label: 'Edit' },
                                            // { id: 'delete', label: 'Delete' }
                                        ]}

                                        order={order}
                                        orderBy={orderBy}
                                        onRequestSort={handleSort}
                                        numSelected={selected.length}
                                        rowCount={compData.length}
                                        onSelectAllClick={handleSelectAllClick}
                                    />
                                    <tbody>
                                        {displayedData && displayedData.length > 0 ? (
                                            <>
                                                {displayedData?.map((row) => (
                                                    <TableBody2
                                                        key={row.srNo}
                                                        id={row.srNo}
                                                        stkBarcode={row.stkBarcode}
                                                        stkId={row.stkId}
                                                        itemId={row.itemId}
                                                        itemNm={row.itemNm}
                                                        size={row.size}
                                                        color={row.color}
                                                        qty={row.qty}
                                                        bqty={row.bqty}
                                                        disrate={row.disrate}
                                                        disamt={row.disamt}
                                                        srate={row.srate}
                                                        schlId={row.schlId}
                                                        schlcd={row.schlcd}
                                                        schlNm={row.schlNm}
                                                        serialNumber={row.serialNumber}
                                                        handleClick={(event) => handleClick(event, row.name)}
                                                    />
                                                ))}

                                                <TableBottom2
                                                    totbalqty={totbalqty}
                                                    totsaleqty={totsaleqty}
                                                    totstkqty={totstkqty}
                                                    totdisamt={totdisamt}
                                                    totdisrate={totdisrate}
                                                />

                                            </>
                                        ) : (
                                            <tr>
                                                <td colSpan={12} style={{ textAlign: "center", padding: "10px" }}>
                                                    No data available
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </Table>
                            </TableContainer>

                            <Pagination
                                currentPage={currentPage}
                                handlePageChange={handlePageChange}
                                handlePreviousPageRange={handlePreviousPageRange}
                                visiblePageNumbers={visiblePageNumbers}
                                pageNumber={pageNumbers}
                                pageRange={pageRange}
                                totalPages={totalPages}
                                handleNextPageRange={handleNextPageRange}
                            />
                        </Paper>
                    </Grid>
                </Grid>
            </div>

        </>
    );
}

export default UstkDetailsReg;
